import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { IconButton, Tooltip } from '@mui/material';
import Icons from '../../../components/icons';

export const gradeEntriesColumns = (
  onEdit: (gradeKey: string) => void,
  onDelete: (gradeKey: string) => void
): GridColDef[] => [
  { field: 'grade', headerName: 'Grade', flex: 1 },
  { field: 'min', headerName: 'Min', flex: 1 },
  { field: 'max', headerName: 'Max', flex: 1 },
  {
    field: 'update',
    headerName: 'Update',
    flex: 1,
    sortable: false,
    renderCell: (params) =>
      React.createElement(Tooltip, {
        title: 'Update',
        children: React.createElement(
          IconButton,
          { onClick: () => onEdit(params.row.grade as string) },
          React.createElement(Icons.EditBlackOutlined, null)
        )
      })
  },
  {
    field: 'delete',
    headerName: 'Delete',
    flex: 1,
    sortable: false,
    renderCell: (params) =>
      React.createElement(Tooltip, {
        title: 'Delete',
        children: React.createElement(
          IconButton,
          { onClick: () => onDelete(params.row.grade as string) },
          React.createElement(Icons.Delete, { width: 20, height: 20 })
        )
      })
  }
];

export default gradeEntriesColumns;
